import Squircle from "./Squircle";
import "./styles/characterPortrait.scss";

interface IProps {
    avatar: string;
    size: "small" | "medium" | "large";
}

const CharacterPortrait = ({ avatar, size = "small" }: IProps) => {
    return (
        <div className={`character-portrait character-portrait--${size}`}>
            <Squircle />
            <img className="character-portrait__image" src={avatar} />
            <div
                className="character-portrait__decoration__wrapper"
                aria-hidden
            >
                <div
                    className="character-portrait__decoration"
                    aria-hidden
                ></div>
            </div>
        </div>
    );
};
export default CharacterPortrait;
